import { render } from "./CadFinancasCategoriaDespesa.vue?vue&type=template&id=30fd324a"
import script from "./CadFinancasCategoriaDespesa.vue?vue&type=script&lang=js"
export * from "./CadFinancasCategoriaDespesa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__